<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-verify-email',
    }"
  >
    <h4 class="mt-6 mb-9">
      Check your inbox!
    </h4>
    <p class="p3 mb-6">
      You're almost in, {{ firstName }}! Just verify your email by
      following the link we've sent to {{ email }}.
    </p>
    <h4 class="mb-4">
      Didn't receive it?
    </h4>
    <WizardFooter>
      <h5 class="mb-6">
        Check your spam folder or<br> resend it
        by <a @click="resendVerificationEmail">clicking here</a>.
      </h5>
      <h5>
        Having trouble?
        <a
          :href="'mailto:hello@datapeople.io'
            + '?subject=Having%20issues%20verifying%20email%20on%20JobNav'"
        >
          Contact Us
        </a>
      </h5>
    </WizardFooter>
  </WizardContent>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';
import { signupResendVerificationEmail } from '@/api/signup';
import WizardContent from '@/components/shared/WizardContent.vue';
import WizardFooter from '@/components/shared/WizardFooter.vue';

export default {
  name: 'VerifyEmail',
  components: {
    WizardContent,
    WizardFooter,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useWizard, ['firstName', 'email']),
  },
  created() {
    this.updateFlash({ status: 'success', message: 'Email sent! Please check and confirm.' });
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Verify Email' });
  },
  methods: {
    ...mapActions(useWizard, ['updateFlash', 'resetFlash']),
    async resendVerificationEmail() {
      try {
        this.resetFlash();
        await signupResendVerificationEmail();
        this.updateFlash({ status: 'success', message: 'Verification email resent!' });
      } catch (e) {
        this.updateFlash({ message: 'Something went wrong' });
      }
    },
  },
};
</script>
